import CreditCardDetails from './CreditCardDetails';

export default CreditCardDetails;
